import { Link, useIntl } from 'gatsby-plugin-intl'
import React from 'react'
import Layout from '../../components/Layout/index'
import PressRelease from '../../components/PressRelease'
import SEO from '../../components/seo'
import Footer from '../../modules/Footer'
import Header from '../../modules/Header'

import Image from '../../images/news/interactive-modules-teaser.png'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import messages from '../../messages/pageTitles.lang'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsInteractiveModules)}
        imageAlt={formatMessage(messages.TitleNewsInteractiveModules)}
        description={formatMessage(metaDescription.NewsInteractiveModulesDescription)}
        image={Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.interactiveModules}
        articleLinks={{
          quickstart: (
            <Link to="/products/quickstart/">
              QuickStart
            </Link>
          ),
          freshms: (
            <Link to="/products/freshms/">
              freshMS
            </Link>
          )
        }}
      />
    </Layout>
  )
}

export default IndexPage
